import { Typography } from "@material-ui/core";
import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const Conversion = () => {
  const [conversion, setConversion] = useState({
    series: [
      {
        name: 2023,
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
      },
      {
        name: 2022,
        data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
        ],
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
  });

  return (
    <div>
      <Typography variant="h5" className="adminHomeTitle">
        Conversion
      </Typography>
      <ReactApexChart
        options={conversion.options}
        series={conversion.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default Conversion;
